import { Link } from "react-router-dom"

function Luoghi() {
    return (<>
        <h5 className='mt-3 text-center'>LUOGHI IMPERDIBILI IN ITALIA</h5>
        <div className='bodyPadding mt-3 text-center' style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>
            <Link to={{ pathname: "/venezia" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("../image/claudio-schwarz-VlI9IQgMilw-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
            <Link to={{ pathname: "/civita" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("../image/gabriele-merlino-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
            <Link to={{ pathname: "/firenze" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("../image/alexandra-smielova-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
            <Link to={{ pathname: "/roma" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("../image/caleb-miller-0Bs3et8FYyg-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
            <Link to={{ pathname: "/orvieto" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("../image/mario-la-pergola-AeGitzwf3qw-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
            <Link to={{ pathname: "/matera" }} style={{ textDecoration: 'none', color: 'black' }}>
                <img src={require("../image/moira-nazzari-BY25ED6PSJk-unsplash.jpg")} width={130} height={100}
                    style={{ borderRadius: '20px', margin: '0.5rem' }} alt='' />
            </Link>
        </div>
    </>
    )
}
export default Luoghi